import { Grid, Typography } from '@mui/material';
import styles from '../Information/Information.module.scss';
import { useNavigate } from 'react-router-dom';

const Overview = () => {
    const navigation = useNavigate();
    const handlePriestsClick = () => {
        navigation('/priests');
    }

    const steeringCompo = (): React.ReactElement => {
        return <div>
            <Grid sx={{ marginTop: "20px" }}>
                <Typography className={styles.headercontent}>
                    Management
                </Typography>
            </Grid>
            <Grid>
                <ul style={{ paddingInlineStart: "22px" }}>
                    <li className={styles.listtext}>Steering Committee:</li>
                    <div style={{ paddingLeft: "20px" }}>
                        <li className={styles.listtext}>The supreme body of HCCC. Meets once a quarter.</li>
                        <li className={styles.listtext}>Elects Board of Directors (BOD) and Executive Committee (EC) members through an election process.</li>
                        <li className={styles.listtext}>Advises the BOD on the strategic matters.</li>
                        <li className={styles.listtext}>Reviews and approves the annual budget and the resolutions recommended by BOD.</li>
                    </div>
                    <li className={styles.listtext}>Board of Directors (BOD):</li>
                    <div style={{ paddingLeft: "20px" }}>
                        <li className={styles.listtext}>Consists of nine members headed by a Chairman. Meets once a month or as needed.</li>
                        <li className={styles.listtext}>Has fiduciary responsibility and oversees the temple operations guiding EC.</li>
                        <li className={styles.listtext}>Review and approve resolutions recommended by EC.</li>
                        <li className={styles.listtext}>Review and recommend annual budget proposed by Treasurer to SC.</li>
                    </div>
                    <li className={styles.listtext}>Executive Committee (EC):</li>
                    <div style={{ paddingLeft: "20px" }}>
                        <li className={styles.listtext}>Consists of multiple members headed by a President who is a board member. Meets once a month or as needed.</li>
                        <li className={styles.listtext}>Each member can opt as a chair of a functional area as per the board approval.</li>
                        <li className={styles.listtext}>Each chair oversees the assigned functional area tasks and the respective budget.</li>
                        <li className={styles.listtext}>Treasurer oversees all the financial aspects and the overall budget.</li>
                        <li className={styles.listtext}>Reviews and approves the operational resolutions.</li>
                    </div>
                </ul>
            </Grid>
        </div>;
    }
    const historicalInformation = (): React.ReactElement => {
        return (
            <>
                <Grid>
                    <Typography className={styles.content}>
                        HCCC was established in 1977 with the goal of offering religious services to Hindu community. In the last 35 years the HCCC has evolved into an established institution as a place of worship with the needed services for the community.
                    </Typography>
                    <Typography className={styles.headercontent}>HCCC Historical Information</Typography>
                </Grid>
                <Grid>
                    <Typography className={styles.infomationtypo}>
                        <span>1977</span>: HCCC was incorporated<br />
                        <span>1980 - 83</span>: Land acquired in Livermore<br />
                        <span>1983 – 86</span>: Interim Temple.<br />
                        <span>1984 - 85</span>: Idols donated by Tamil Nadu Govt. & TTD<br />
                        <span>1984 - 86</span>:
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Foundation stone laid by Sri. N.T. Rama Rao.</li>
                            <li className={styles.listtexth}>Shilpis arrive from India and major construction began.</li>
                            <li className={styles.listtexth}>Foundation ceremonies for cultural center by Pdt. Ravi Shankar and Ustad Ali Akbar Khan</li>
                        </ul>
                        <span>1986</span>: Kumbhabhishekam - July 13<br />
                        <span>1992</span>: Enclosure and roof completed & Raja gopuram and other Gopurams completed<br />
                        <span>1997</span>: Assembly Hall inaugurated by Livermore City Councilman
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}> Inaugural concert by K.J. Yesudas & Party</li>
                        </ul>
                        <span>1998</span>: Mahakumbhabhishekam in July 5
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Dakshina Bhoomi purchased</li>
                        </ul>

                        <span>1999</span>: Poorva Bhoomi purchased<br />
                        <span>2001</span>: Temple Flooring completed<br />
                        <span>2002</span>: 25th Anniversary Celebrations<br />
                        <span>2003</span>: Endowment Fund Intiation.<br />
                        <span>2010</span>: Mahakumbhabhishekam II - June 16<br />
                        <span>2011</span>: Kanaka Durga Prayer Hall completion<br />
                        <span>2012</span>:
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}> Administrative Building Completion.</li>
                            <li className={styles.listtexth}>Multi-Purpose Building Completion.</li>
                            <li className={styles.listtexth}>Akella Annadana Kitchen Completion</li>
                        </ul>
                        <span>2013</span>:
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Lakireddy Auditorium Completion</li>
                            <li className={styles.listtexth}>East Parking Lot Completion</li>
                        </ul>
                        <span>2016</span>: Solar Project<br />
                        <span>2019</span>: Temple 33rd Anniversary<br />
                        <span>2022</span>: Mahakumbhabhishekam III July 10
                        <ul style={{ paddingInlineStart: "22px", marginTop: "10px" }}>
                            <li className={styles.listtexth}>Panavattam in Shiva Shrine</li>
                            <li className={styles.listtexth}>Kohstha vigrahas for Balaji Shrine</li>
                            <li className={styles.listtexth}>Sri Chandikeshwara deity</li>
                            <li className={styles.listtexth}>new moola murthies of Sri Rama Parivar</li>
                            <li className={styles.listtexth}>gold plated Dwajasthambhas</li>
                            <li className={styles.listtexth}>Alaya Shikar Kalasha and Prabhavalis</li>
                        </ul>
                    </Typography>
                </Grid>
            </>
        )
    }
    const serviceOffered = (): React.ReactElement => {
        return (
            <Grid sx={{ marginTop: "32px 0 8px 0" }}>
                <Typography className={styles.headercontent}>Services Offered by HCCC</Typography>

                <Typography>
                    <ul style={{ paddingInlineStart: "22px" }}>
                        <div className={styles.listtext}>
                            <li>Religious Services at temple and devotee residences</li>
                            <li>Renting of Facilities</li>
                            <li>Human Services</li>
                            <li>Youth and Education</li>
                            <li>Cultural Events</li>
                            <li>Spiritual Services</li>
                        </div>
                    </ul>
                    <div className={styles.listtext}>
                        Additional details on the above services are furnished in the subsequent sections.
                    </div>
                </Typography>
            </Grid>
        )
    }
    const devotees = (): React.ReactElement => {
        return (
            <div>
                <Grid sx={{ marginTop: "24px 0px 8px 0px" }}>
                    <Typography className={styles.headercontent}>Devotees</Typography>
                    <ul style={{ paddingInlineStart: "22px" }}>
                        <li className={styles.listtext}>The participation and support of the devotees keep the HCCC momentum going. The HCCC is sustained by the generosity of devotees.</li>
                        <li className={styles.listtext}>Devotee feedback on the services and the operational aspects will be well appreciated and helpful in serving the devotee and the community needs.</li>
                    </ul>
                </Grid>
            </div>
        )
    }

    const donors =(): React.ReactElement =>{
        return(
            <div>
                 <Grid sx={{ marginTop: "24px 0px 8px 0px" }}>
                    <Typography className={styles.headercontent}>Donors</Typography>
                    <ul style={{ paddingInlineStart: "22px" }}>
                        <li className={styles.listtext}>There are many ways donors contribute such as hundi donation, religious services, annadana program, construction programs, abharanas, abharana account, endowment account, etc.</li>
                        <li className={styles.listtext}>HCCC greatly appreciates the support and generosity of the donors.</li>
                    </ul>
                </Grid>
            </div>
        )
    }
    const volunteers = (): React.ReactElement => {
        return (
            <Grid sx={{ marginTop: "24px 0px 8px 0px" }}>
                <Typography className={styles.headercontent}>Volunteers</Typography>
                <ul style={{ paddingInlineStart: "22px" }}>
                    <li className={styles.listtext}>It would not have been possible to build this institution without the dedicated support of many volunteers.</li>
                    <li className={styles.listtext}>Volunteers play various roles and help in many operational aspects to serve the devotee and the community needs supported by the management and the support staff:</li>
                    <li className={styles.listtext}>Coordinating events</li>
                    <li className={styles.listtext}>Assisting in event activities</li>
                    <li className={styles.listtext}>Parking control during major events</li>
                    <li className={styles.listtext}>Fund raising support</li>
                    <li className={styles.listtext}>Garland making for the deities</li>
                    <li className={styles.listtext}>In the front office</li>
                    <li className={styles.listtext}>In the kitchen</li>
                    <li className={styles.listtext}>Maintenance & construction support</li>
                    <li className={styles.listtext}>Each year HCCC management awards Steering Committee membership to the dedicated volunteers as per the HCCC policy.</li>
                </ul>
            </Grid>
        )
    }
    const priestandPanchakas = (): React.ReactElement => {
        return (
            <Grid sx={{ marginTop: "20px" }}>
                <Typography className={styles.headercontent}>Priests and Pachakas</Typography>
                <ul style={{ paddingInlineStart: "22px" }}>
                    <li className={styles.listtext}>Our priests are well versed with the pujas, chanting, Hindu traditions and sampradayas. They speak multiple languages.</li>
                    <li className={styles.listtext}>Pachakas support the priests with the neivedyam preparation. They also make the laddu and vada prasadam, and annadana food served on the weekends.</li>
                    <li className={styles.listtext}>The HCCC has 12 priests and two pachakas, are supported by the management, the supporting staff and the volunteers.</li>
                </ul>
                <Typography className={styles.headername} onClick={handlePriestsClick}>
                    Our Priests and Pachakas Details
                </Typography>
            </Grid>
        )
    }
    const supportStaff = (): React.ReactElement => {
        return (
            <Grid sx={{ marginTop: "20px" }}>
                <Typography className={styles.headercontent}>Support Staff</Typography>
                <ul style={{ paddingInlineStart: "22px" }}>
                    <li className={styles.listtext}>Includes a Manager, Assistant Manager, front desk staff, maintenance staff and a part-time librarian.</li>
                    <li className={styles.listtext}>Plays a key role in the day to day operations of HCCC supported by the management.</li>
                </ul>
            </Grid>
        )
    }
    return (
        <>
            <div className={styles.OverView}>
                <Typography className={styles.typoGraphyHeading}>
                    Overview
                </Typography>
                <Grid>
                    <div className={styles.cardContainer}>
                        <div style={{ padding: "24px 0px" }}>
                            {historicalInformation()}
                            {serviceOffered()}
                            {devotees()}
                            {donors()}
                            {volunteers()}
                            {priestandPanchakas()}
                            {supportStaff()}
                            {steeringCompo()}
                        </div>
                    </div>
                </Grid>
            </div>
        </>
    )
}
export default Overview;